require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-shatteringstereotypes.json") })
        }
      }, "path---insights-shatteringstereotypes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-shatteringstereotypes!./.cache/json/insights-shatteringstereotypes.json
// module id = 1151
// module chunks = 231608221292675